import React, { memo } from "react";
import "./style.scss";

import StrapDrop from "../StrapDrop";
import { useMainContext } from "../../../store/Context";

const Strap = ({ slider = false }) => {
  const context = useMainContext();
  const { product, getHeightStrap, getDicesHeight, isMobile } = context;
  const { strap } = product;

  return (
    <div className="Strap" style={{ height: getHeightStrap() }}>
      <div
        className="Strap__Big"
        style={{
          backgroundImage: `url(${strap.images[1].image1})`
        }}
      >
        <StrapDrop isSlider={slider} />
      </div>
      <div
        className="Strap__Small"
        style={{
          backgroundImage: `url(${
            !isMobile ? 
              strap.images[2].image2
              : strap.images[4].image4
          })`,
          top: getDicesHeight()
        }}
      />
    </div>
  );
};

export default memo(Strap);
